import PropTypes from 'prop-types'

/**
 * Defines CSS margin values based on props.
 *
 * @param {object} props Should include `my` || `mx` || `margin`
 * @returns {string} CSS margin declaration
 */
const getMargin = ({ my, mx, margin }) => {
  if (margin) {
    return `margin: ${margin};`
  }

  return `
    margin-top: ${my || 0};
    margin-bottom: ${my || 0};
    margin-right: ${mx || 0};
    margin-left: ${mx || 0};
  `
}
/**
 * Defines CSS padding values based on props.
 *
 * @param {object} props Should include `py` || `px` || `padding`
 * @returns {string} CSS padding declaration
 */
const getPadding = ({ py, px, padding }) => {
  if (padding) {
    return `padding: ${padding};`
  }

  return `
    padding-top: ${py || 0};
    padding-bottom: ${py || 0};
    padding-right: ${px || 0};
    padding-left: ${px || 0};
  `
}
const marginPropTypes = {
  my: PropTypes.string,
  mx: PropTypes.string,
  margin: PropTypes.string
}
const paddingPropTypes = {
  py: PropTypes.string,
  px: PropTypes.string,
  padding: PropTypes.string
}

export { getMargin, getPadding, marginPropTypes, paddingPropTypes }
